<div class="errorDialog">
  <div style="text-align: right">
    <img style="cursor: pointer" src="assets/close-window.svg" (click)="closeDialog()" />
  </div>
  <div style="text-align: center">
    <img src="assets/error.svg" />
  </div>
  <div style="text-align: center">
    <span style="color: rgb(158, 27, 50); font-size: 1.688rem">{{ data.errorType }}</span>
  </div>
  @if (data.errorType !== 'Form Number Limit Exceeded') {
    <div style="text-align: center">
      <span style="color: rgb(158, 27, 50)"
        >Something went wrong on our end. Please try refreshing the page or try again later.</span
      >
    </div>
  }
  <div style="text-align: center">
    <span style="color: rgb(158, 27, 50); font-size: 0.75rem"
      >Error info: {{ data.errorDescription }}</span
    >
  </div>
  <div style="text-align: center">
    <button class="okButton" (click)="closeDialog()">
      <span class="buttonText">OK</span>
    </button>
  </div>
</div>
